import React, { useState, useEffect, useRef } from 'react';
import { FaQuoteLeft, FaStar, FaUserCircle, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const HappyCustomersSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const containerRef = useRef(null);
  const autoScrollRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Aditya Rathore",
      condition: "Urinary Issues",
      testimonial: "After months of anxiety around my urinary issues, I found relief under Dr. Shukla's care. He was professional, respectful, and ensured a quick recovery. I highly recommend him for any urological problems.",
      rating: 5,
      date: "2 weeks ago"
    },
    {
      id: 2,
      name: "Ramesh Jaiswal",
      condition: "Infertility Issue",
      testimonial: "Thanks to Dr. Shukla, I was able to overcome a sensitive infertility issue with confidence. His supportive attitude and expert guidance made a big difference in my journey. Very thankful for his care and discretion.",
      rating: 5,
      date: "1 month ago"
    },
    {
      id: 3,
      name: "Ravi Shukla",
      condition: "Kidney Stones",
      testimonial: "I was suffering from recurring kidney stones and had visited multiple doctors before finding Dr. Shukla. His diagnosis was accurate, and the treatment was smooth and effective. I'm finally pain-free and extremely grateful.",
      rating: 5,
      date: "3 weeks ago"
    },
    {
      id: 4,
      name: "Rajnish Singh",
      condition: "Prostate Condition",
      testimonial: "Dr. Shukla's approach is very patient-centered. He took the time to explain my prostate condition in detail and made me feel comfortable throughout the treatment process. Truly a compassionate and knowledgeable doctor.",
      rating: 5,
      date: "2 months ago"
    },
    {
      id: 5,
      name: "Anil Kumar",
      condition: "UTI Treatment",
      testimonial: "The best urologist in Ranchi! Dr. Shukla treated my chronic UTI with such precision. His modern approach and caring nature made all the difference.",
      rating: 5,
      date: "1 week ago"
    },
    {
      id: 6,
      name: "Suresh Mehta",
      condition: "Prostate Surgery",
      testimonial: "My prostate surgery was done by Dr. Shukla with minimal discomfort. The recovery was faster than expected. Thank you for the excellent care!",
      rating: 5,
      date: "3 weeks ago"
    },
    {
      id: 7,
      name: "Amit Sharma",
      condition: "Kidney Treatment",
      testimonial: "Professional, experienced, and compassionate. Dr. Shukla explained everything clearly and the treatment was very effective. Highly recommended!",
      rating: 5,
      date: "1 month ago"
    },
    {
      id: 8,
      name: "Vikram Singh",
      condition: "Male Health Issues",
      testimonial: "Dr. Shukla provides exceptional care with a personal touch. He listens carefully and provides solutions that actually work. Best urologist!",
      rating: 5,
      date: "2 weeks ago"
    },
    {
      id: 9,
      name: "Rajesh Verma",
      condition: "Bladder Issue",
      testimonial: "After struggling with bladder issues for years, Dr. Shukla provided the right treatment. His expertise is remarkable. Thank you doctor!",
      rating: 5,
      date: "3 months ago"
    },
    {
      id: 10,
      name: "Sanjay Gupta",
      condition: "Laparoscopic Surgery",
      testimonial: "Minimally invasive surgery done perfectly by Dr. Shukla. The scars are minimal and recovery was quick. Excellent surgical skills!",
      rating: 5,
      date: "1 month ago"
    },
    {
      id: 11,
      name: "Manoj Tiwari",
      condition: "Erectile Dysfunction",
      testimonial: "Dr. Shukla handled my sensitive issue with great care and professionalism. The treatment was successful and discreet. Highly grateful.",
      rating: 5,
      date: "2 months ago"
    },
    {
      id: 12,
      name: "Prakash Yadav",
      condition: "Urological Checkup",
      testimonial: "Regular checkups with Dr. Shukla have kept my urological health perfect. His preventive approach is what makes him the best.",
      rating: 5,
      date: "3 weeks ago"
    }
  ];

  const cardsPerView = 4;
  const totalSlides = Math.ceil(testimonials.length / cardsPerView);

  useEffect(() => {
    if (isPaused) return;

    autoScrollRef.current = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % totalSlides);
    }, 4000);

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
      }
    };
  }, [totalSlides, isPaused]);

  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const getVisibleTestimonials = () => {
    const startIndex = currentIndex * cardsPerView;
    return testimonials.slice(startIndex, startIndex + cardsPerView);
  };

  const visibleTestimonials = getVisibleTestimonials();

  return (
    <section 
      className="py-8 md:py-10 lg:pt-6 lg:pb-12 bg-gradient-to-b from-blue-50/30 to-white -mt-4 lg:-mt-8"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="container mx-auto px-4">
        
        <div className="text-center mb-6 max-w-3xl mx-auto">
          <div className="inline-flex items-center mb-3 px-4 py-1.5 bg-gradient-to-r from-sky-50 to-red-50 rounded-full border border-sky-200 shadow-sm">
            <div className="flex items-center space-x-1">
              <div className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></div>
              <div className="w-1.5 h-1.5 bg-sky-500 rounded-full animate-pulse delay-75"></div>
              <div className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse delay-150"></div>
            </div>
            <span className="ml-2 text-xs font-semibold text-sky-600">Patient Stories</span>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">
            Happy <span className="bg-gradient-to-r from-sky-600 to-red-500 bg-clip-text text-transparent">Customers</span>
          </h2>
          <p className="text-gray-600 text-sm">
            What our patients say about their experience with Dr. Shukla
          </p>
        </div>

        <div className="relative mb-5">
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-3 md:-translate-x-4 z-10 w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-r from-sky-500 to-sky-600 text-white flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300"
          >
            <FaChevronLeft className="text-xs" />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-3 md:translate-x-4 z-10 w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-r from-red-500 to-red-600 text-white flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300"
          >
            <FaChevronRight className="text-xs" />
          </button>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" ref={containerRef}>
            {visibleTestimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100 p-4"
              >
                <div className="absolute -top-2 -left-2 w-8 h-8 rounded-full bg-gradient-to-r from-sky-500 to-red-500 flex items-center justify-center shadow-md">
                  <FaQuoteLeft className="text-white text-xs" />
                </div>
                <div className="flex mb-3 justify-end">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-500 text-xs" />
                  ))}
                </div>
                <div className="mb-4">
                  <p className="text-gray-700 text-xs leading-relaxed italic">
                    "{testimonial.testimonial}"
                  </p>
                </div>
                <div className="flex items-center pt-3 border-t border-gray-100">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-r from-sky-100 to-red-100 flex items-center justify-center mr-3">
                    <FaUserCircle className="text-sky-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 text-sm">{testimonial.name}</h4>
                    <div className="flex flex-col sm:flex-row sm:items-center text-xs text-gray-600">
                      <span className="px-1.5 py-0.5 bg-sky-50 text-sky-600 rounded mr-2 mb-1 sm:mb-0 inline-block w-fit">
                        {testimonial.condition}
                      </span>
                      <span>{testimonial.date}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="flex justify-center items-center space-x-2 mb-6">
          {[...Array(totalSlides)].map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === currentIndex 
                  ? 'bg-gradient-to-r from-sky-500 to-red-500 scale-125' 
                  : 'bg-gray-300 hover:bg-gray-400'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
        
        <div className="flex items-center justify-center">
          <div className="flex items-center text-gray-500 text-xs">
            <div className={`w-2 h-2 rounded-full mr-1 ${isPaused ? 'bg-gray-400' : 'bg-green-500 animate-pulse'}`}></div>
            <span>{isPaused ? 'Paused' : 'Auto-scrolling'}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HappyCustomersSection;